export default __webpack_public_path__ + "static/media/download-cloud.59da2abc.svg";